const Fetcher = require('./fetcher');

const ANCILLARIES_SERVICES = {BAGS: 'BAGS', SEATS: 'SEATS'};

class PbAncillariesCollection {
    constructor() {
        this.tripBagsFetcher = new Fetcher({service: ANCILLARIES_SERVICES.BAGS, action: 'getBags'});
        this.tripSeatsFetcher = new Fetcher({service: ANCILLARIES_SERVICES.SEATS, action: 'getSeats'});
    }

    loadTripBags(bookingDetailDTO = {}) {
        return this.tripBagsFetcher.load(bookingDetailDTO);
    }

    onTripBagsLoaded(data = {}) {
        this.tripBagsFetcher.subscribe(data);
    }

    loadTripSeats(bookingDetailDTO = {}) {
        return this.tripSeatsFetcher.load(bookingDetailDTO);
    }

    onTripSeatsLoaded(data = {}) {
        this.tripSeatsFetcher.subscribe(data);
    }
}

module.exports = new PbAncillariesCollection();
